module.exports = __webpack_public_path__ + "static/img/invest-TMT1.8aeb26c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT1.jpg
// module id = wSTB
// module chunks = 0